import { Outlet, useLoaderData, useLocation } from 'react-router';
import { Suspense, useEffect } from 'react';
import { RouteErrorBoundary } from '@/layouts/route-error-boundary';

import { Loader } from '@/components/ui/loader';
import { useAuthStore } from '@/features/auth/auth.store';

import { ConsoleHeader } from './console-header';
import { ConsoleSidebar } from './console-sidebar';

const ConsoleLayout = () => {
  const setPermissions = useAuthStore(state => state.setPermissions);
  const setUser = useAuthStore(state => state.setUser);
  const { user, permissions } = useLoaderData();
  const { pathname } = useLocation();

  useEffect(() => {
    setPermissions(permissions);
    setUser(user);
  }, [permissions, setPermissions, user, setUser]);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pathname]);

  return (
    <div className="bg-neutral-90 flex min-h-screen">
      <ConsoleSidebar />

      <div className="flex flex-1 flex-col space-y-6 overflow-x-hidden md:p-6">
        <ConsoleHeader />

        <main className="flex-1">
          <div className="h-full min-w-full">
            <RouteErrorBoundary>
              <Suspense
                fallback={
                  <div className="flex h-full w-full items-center justify-center">
                    <Loader />
                  </div>
                }
              >
                <Outlet />
              </Suspense>
            </RouteErrorBoundary>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ConsoleLayout;
